import React from 'react'

function PromoCodeThreeIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1288" height="80" viewBox="0 0 1288 80" {...props}>
      <defs>
        <clipPath id="promo-code-three-icon-id">
          <rect
            width="1288"
            height="80"
            data-name="Rectangle 9780"
            opacity="0.03"
            rx="8"
            transform="translate(-20429 -4498)"
          ></rect>
        </clipPath>
      </defs>
      <g clipPath="url(#promo-code-three-icon-id)" data-name="Mask Group 707" transform="translate(20429 4498)">
        <g data-name="Group 57908" transform="translate(-19902.369 -4513.675)">
          <g
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            data-name="Group 57912"
            transform="translate(2.521 -3.096)"
          >
            <path
              d="M492.568 111.183c0-15.467-15.541-10.727-15.541-10.727s2.425-11.021-14.151-11.021c.951-15.542-26.275-24.3-41.061-12.979"
              data-name="Path 1347"
              opacity="0.8"
            ></path>
            <path
              d="M381.333 111.184c0-10.09 9.6-7 9.6-7s-1.5-7.19 8.739-7.19c-.666-11.5 21.037-17.3 28.477-4.838"
              data-name="Path 17167"
              opacity="0.8"
            ></path>
          </g>
          <g
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            data-name="Group 57911"
            transform="translate(56.02 10.083)"
          >
            <path
              d="M-.001 24.995c0 13.908 13.635 9.646 13.635 9.646s-2.128 9.91 12.416 9.91c-.835 13.976 23.054 21.848 36.027 11.67"
              data-name="Path 17169"
              opacity="0.8"
            ></path>
            <path
              d="M103.607 24.994c0 9.75-9.332 6.762-9.332 6.762s1.456 6.947-8.5 6.947c.648 11.108-20.455 16.717-27.689 4.675"
              data-name="Path 17168"
              opacity="0.8"
            ></path>
          </g>
          <g data-name="Group 57909" transform="rotate(-11 202.906 -924.92)">
            <g data-name="Group 51553" transform="translate(-7.878 10.994)">
              <g data-name="Group 6310" transform="rotate(169 65.934 66.262)">
                <path
                  fill="#263238"
                  d="M47.244 58.778c.014-.029-6.025-7.539-9.443-10.944a39.277 39.277 0 00-7.713-6.1 14.924 14.924 0 01-5.488-4.959c-1.278-2.154-1.68-6.628.582-8.373 2.485-1.925 6.463-1.824 9.393-1.723a90.432 90.432 0 0110.951 1.228c3.483.539 6.966 1.163 10.485 1.487 2.528.237 5.422.488 7.856-.438a4.9 4.9 0 002.111-1.436 5.744 5.744 0 00.718-1.357 4.927 4.927 0 00.151-.625c.172-.5.323 2 0-.223a15.525 15.525 0 00-2-5.953C61.9 14.477 56.53 11.46 51.488 9.184c-7.339-3.311-15.749-6.463-23.9-6.413-7.749.086-15.662 2.937-21.178 8.488a21.767 21.767 0 00-5.585 9.379 19.081 19.081 0 00-.546 2.621A15.729 15.729 0 00.121 24.9c.05-1.472.079.4.18 1.1a24.673 24.673 0 001.831 6.25c.345.8-.338 2.032 0 2.822-3.778-8.861-2.65-19.64 4.308-26.628A29.443 29.443 0 0121.521.588C28.566-.848 35.165.53 41.88 2.742c8.732 2.873 21.063 6.995 24.323 16.7a19.663 19.663 0 01.718 8.718c-.675 4.215-5.6 4.309-8.984 4.18-6.6-.316-13.077-1.953-19.648-2.6-3.7-.366-14.039-1.645-14.564 4.086v-2.484c.244 2.413 2.039 4.381 3.849 5.846 2.7 2.154 5.745 3.648 8.373 6.018a88.594 88.594 0 0111.312 12.728c.46.618 0 2.815 0 2.815z"
                  data-name="Path 2080"
                ></path>
                <path
                  fill="#d3dade"
                  d="M39.573 56.221s-4.731-10.093-8.079-14.549c-1.508-2.039-4.6-4.309-4.89-6.951-.079-.668-.287-2.262.172-2.873.754-.955 3.275-.646 4.309-.639 7.476.057 14.908 1.063 22.4.718 4.309-.2 12.208-.618 12.675-6.377v1.436c0-2.592-1.5-6.147-2.492-8.574a27.936 27.936 0 00-6.214-9.552 20.991 20.991 0 00-11.21-5.623c-5.537-.926-11.038.424-16.517 1.063-4.826.56-9.7.876-14.485 1.759-3.317.618-6.864 1.541-9.414 3.878s-3.72 6.154-3.677 9.594c.086 6.1 1.35 12.244 2.018 18.305S5.476 50.361.141 54.461c.438-.338-.474-2.456 0-2.815a10.772 10.772 0 003.591-4.309 11.7 11.7 0 00.646-2.614 8.313 8.313 0 00.079-.941c-.05 1.092 0 .28 0 0a74.868 74.868 0 00-.223-2.585C3.516 34.2 2.159 27.216 2.08 20.164c-.036-4.388 0-9.257 3.275-12.632 3.512-3.648 9.249-4.309 14-4.941 3.447-.431 6.908-.718 10.355-1.142C33.67.99 37.613.106 41.627.013a21.924 21.924 0 0116.581 6.743 31.32 31.32 0 016.938 13.164c.8 2.923 1.86 7.074.718 10.054-3.871 9.874-38.836.675-39.181 5.106v-2.823c.108.984 1.041 1.86 1.637 2.571 1.336 1.587 2.68 3.152 3.88 4.854 3.05 4.218 8.492 16.858 8.492 16.858z"
                  data-name="Path 2081"
                  transform="translate(7.563 .963)"
                ></path>
                <path
                  fill="#fe5f55"
                  d="M0 0l59.2 28.861-26.633 9.845z"
                  data-name="Path 78519"
                  transform="translate(47.243 56.674)"
                ></path>
                <path
                  fill="#fe5f55"
                  d="M0 8.4L23.712 0l20.194 24.556z"
                  data-name="Path 78520"
                  transform="translate(56.24 96.031)"
                ></path>
                <path
                  fill="#fff"
                  d="M0 9.869L27.11 0l-5.832 34.457z"
                  data-name="Path 78521"
                  transform="translate(79.872 85.931)"
                ></path>
                <path
                  fill="#fff"
                  d="M0 0l32.419 37.613-23.251 8.82z"
                  data-name="Path 78522"
                  transform="translate(47.016 57.778)"
                ></path>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M107.218 85.436L78.162 71.447l-.022-.007-19.037-9.164-.014-.007-1.271-.618h-.007l-4.269-2.053h0l-.758-.369-2.787-1.341-.5-.244-1.92-.926-.388-.18-.847-.409.1.5 9.48 47.974 7.6 2.758 13.328 4.826.043.022 14.262 5.163.036.022 9.817 3.555 1.278-7.339h0l.05-.23 1.923-11.011.007-.036 2.118-12.129z"
                  data-name="Path 2072"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M0 19.167L51.296 0"
                  data-name="Line 256"
                  transform="translate(55.922 85.436)"
                ></path>
                <path
                  fill="#eceff1"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M54.671 64.818L0 0"
                  data-name="Line 257"
                  transform="translate(46.343 56.129)"
                ></path>
              </g>
              <path
                fill="none"
                stroke="#263238"
                strokeLinejoin="round"
                strokeWidth="1"
                d="M47.631 39.759c-124.641 13.256 44.39 94.783-37.7 112.627"
                data-name="Path 17172"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default PromoCodeThreeIcon
